import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import colors from 'src/styles/equalution/colors';
import { Button } from 'reactstrap';
import CheckIcon from '@mui/icons-material/Check';
import { useAppSelector } from 'src/store/hooks';
import SupplementIcon from 'src/assets/icons/supplement-icon.svg';
import { isUserFromAustralia } from 'src/lib/utils';
import { SupplementDetails } from './SupplementDetails';
import { useAddonFeatures } from 'src/pages/subscription-new/hooks/useAddonFeatures';

interface SupplementPackageCardProps {
  onCtaClick?: () => void;
  price?: string | number;
  isSupplementAdded?: boolean;
}

export const SupplementPackageCard: FC<SupplementPackageCardProps> = ({
  price = '$XX',
  onCtaClick,
  isSupplementAdded,
}) => {
  const isAustralianUser = isUserFromAustralia();
  const isPaymentProcessing = useAppSelector(
    state => state.payment.isPaymentProcessing
  );
  const supplementFeatures = useAddonFeatures();

  if (!isAustralianUser) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        textAlign: 'center',
        backgroundColor: colors.WHITE,
        borderRadius: '20px',
      }}>
      <Box
        sx={{
          backgroundColor: colors.WHITE,
          padding: '16px',
          borderRadius: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '12px',
        }}>
        <Box mb={0}>
          <img
            src={SupplementIcon}
            alt="Supplement Icon"
            width={40}
            height={40}
          />
        </Box>
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 700,
            color: colors.SALAD,
            lineHeight: '0px',
          }}>
          Supplement Pack
        </Typography>
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 700,
            color: colors.OFF_BLACK,
          }}>
          {typeof price === 'number' && (
            <Box
              component="span"
              sx={{
                textDecoration: 'line-through',
                fontWeight: 400,
                mr: 1,
              }}>
              ${Number(price) + 10}
            </Box>
          )}
          ${typeof price === 'number' ? Number(price).toFixed(0) : price}
        </Typography>
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: 600,
            color: colors.OFF_BLACK,
            lineHeight: '0px',
          }}>
          One-time purchase
        </Typography>
        <Typography
          sx={{
            fontSize: '15px',
            fontWeight: 300,
            color: colors.OFF_BLACK,
            lineHeight: '20px',
            marginTop: '12px',
            marginBottom: '4px',
          }}>
          Support your results with expertly crafted supplements designed to
          fuel and accelerate your progress.
        </Typography>
        <SupplementDetails features={supplementFeatures} />
        <Button
          disabled={isSupplementAdded || isPaymentProcessing}
          onClick={onCtaClick}
          style={{
            height: '52px',
            fontWeight: 600,
            fontSize: '16px',
            width: '100%',
            backgroundColor: isSupplementAdded
              ? `${colors.OFF_BLACK}4D`
              : colors.OFF_BLACK,
            border: 'none',
            padding: 0,
          }}>
          {isSupplementAdded && (
            <CheckIcon
              sx={{ color: colors.WHITE, fontSize: 20, mb: -0.5, mr: 1 }}
            />
          )}
          {isSupplementAdded
            ? 'Added Supplement Pack'
            : 'Add a Supplement Pack'}
        </Button>
      </Box>
    </Box>
  );
};
